import { defineComponent, reactive, watch, onMounted, toRefs, computed } from 'vue';
export default defineComponent({
  name: 'toast',
  props: {
    message: {
      type: String,
      default: '请求超时'
    },
    type: {
      type: String,
      default: 'info', // info, success, warning, error
      validator: (value) => ['info', 'success', 'warning', 'error'].includes(value)
    },
    onClose: {
      type: Function
    },
    duration: {
      type: Number,
      default: 3000
    },
    zIndex: {
      type: Number,
      default: 3000
    }
  },
  setup(props) {
    const state = reactive({
      show: true,
      timer: null,
      closed: false
    });

    // 根据类型计算图标
    const iconPath = computed(() => {
      const icons = {
        success: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z',
        error: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z',
        warning: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z',
        info: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z'
      };
      return icons[props.type] || icons.info;
    });

    const close = () => {
      state.closed = true;
      // 执行关闭回调
      if (typeof props.onClose === 'function') {
        props.onClose(this);
      }
    };

    const startTimer = () => {
      if (props.duration > 0) {
        state.timer = setTimeout(() => {
          if (!state.closed) {
            // 关闭 toast
            close();
          }
        }, props.duration);
      }
    };

    const handleAfterLeave = currentElement => {
      if (currentElement && currentElement.parentNode) {
        currentElement.parentNode.removeChild(currentElement);
      }
    };

    onMounted(() => {
      startTimer();
    });

    watch(
      () => state.closed,
      newVal => {
        if (newVal) {
          state.show = false;
        }
      }
    );

    return {
      ...toRefs(state),
      close,
      handleAfterLeave,
      iconPath
    };
  }
});
